import { css } from '@emotion/react'
import type { Theme } from '@emotion/react'

import { borderRadius, breakpoint, size } from '@twisto/styles'

export const container = (theme: Theme) => css`
  padding: ${size[12]} ${size[16]};
  display: flex;
  flex-direction: column;
  gap: ${size[8]};
  border: 1px solid ${theme.palette.neutral[100]};
  border-radius: ${borderRadius.md};

  ${breakpoint.up('md')} {
    padding: ${size[16]} ${size[24]};
  }
`

export const headline = css`
  display: flex;
  align-items: center;
  gap: ${size[8]};
`

export const icon = css`
  fill: transparent;
`
